"use strict";

exports.__esModule = true;
exports.default = void 0;
var _BrandSt = require("./Brand.st.css.js");
var _default = () => ({
  className: _BrandSt.classes.root
});
exports.default = _default;
//# sourceMappingURL=Brand.js.map